import api from "./api";

export default class PaymentApi {
  static postPaymentSolicitation = async (obj: any, code: any) => {
    const response = await api.post(`/Pagamento`, obj, {
      headers: {
        codigo: code,
      },
    });
    return response.data;
  };

  static getPaymentSolicitation = async (
    idStatus: number,
    idCliente: number,
    dataInicio: string,
    dataFim: string,
    Page: number,
    RecordsPerPage: number,
    Search: string,
    minValue: any,
    maxValue: any
  ) => {
    const response = await api.get(
      `/Pagamento?idStatus=${idStatus}&idCliente=${idCliente}&dataInicio=${dataInicio}&dataFim=${dataFim}&Page=${Page}&RecordsPerPage=${RecordsPerPage}&Search=${Search}&valorInicio=${minValue}&valorFim=${maxValue}`
    );
    return response;
  };

  static getPaymentPerId = async (idPayment: any) => {
    const response = await api.get(`/Pagamento/${idPayment}`);
    return response.data;
  };

  static deletePaymentPerId = async (id: number) => {
    const response = await api.delete(`/Pagamento/${id}`);
    return response.data;
  };

  static exportPayment = async (
    idStatus: any,
    valorInicio: any,
    valorFim: any,
    dataInicio: any,
    dataFim: any,
    id: any,
    search: string
  ) => {
    const response = await api.get(
      `/Pagamento/exportacao/download?idStatus=${idStatus}&idCliente=${id}&dataInicio=${dataInicio}&dataFim=${dataFim}&valorInicio=${valorInicio}&valorFim=${valorFim}&Search=${search}`,
      {
        responseType: "blob",
      }
    );
    return response.data;
  };
}
